import { createElement as rc, useState, useContext, useEffect } from 'react';
import { contexts } from 'lib_ui-primitives';
import MenuItem from '../../menuSelection/MenuItem';
/** A menu option to dispatch an update application runtime clearSession event.
 * This will clear the current user session data, but does not logout (triggers load of
 * selectTenant page).
 * see lib_ui-core/src/rules/application/runtime/doingUpdate_application_runtime_clearSession.js
 * */
export default function TenantSwitcherMenuItem() {
    const [hasMoreThanOneTenant, setHasMoreThanOneTenant] = useState(false);
    const sessionContext = useContext(contexts.SessionContext);
    useEffect(() => {
        if (sessionContext?.profile?.tenant?.length > 1 || sessionContext?.profile?.tenant?.[0]?.useCase?.length > 1) {
            setHasMoreThanOneTenant(true);
        } else {
            setHasMoreThanOneTenant(false);
        }
    }, [sessionContext]);

    if (!hasMoreThanOneTenant) {
        return null;
    }
    // prettier-ignore
    return rc(MenuItem, {
            hNode: {
                forAction: 'update',
                title: 'Switch Tenant',
                namespace: 'application',
                relation: 'runtime',
                type: 'clearSession',
                iconName:'log-in'
            }
        }
    );
}
